// FeatureImage.js
import React, { Component, Fragment } from 'react';
import config from '../../utils/config.js';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { BuyButton } from './BuyButton';
import { FileButton } from './FileButton';
import CropModal from './CropModal';
import Dropzone from 'react-dropzone';
import { uploads as actions, buy } from '../../store/actions';
import { getTemplates, getImageMetaData } from '../../utils/apputils';
import dragIcon from '../../static/images/dragdrop-icon.svg';
import { getImageForCrop } from '../../utils/upload.js';
import Spinner from '../Spinner/Spinner.js';

class FeatureImage_Class extends Component {
  state = {
    show: true
  };

  styles = {
    signing: {
      div_thumbnail: {
        position: 'relative'
      },
      img: {
        opacity: '0.3'
      },
      div_overlay: {
        position: 'absolute',
        top: '1rem',
        left: '1rem',
        width: '100%',
        fontSize: '3rem'
      }
    },
    acceptFile: {
      opacity: 0.5
    }
  };

  componentDidMount() {
    const { dispatch } = this.props;
    const getTemplateData = async () => {
      await getTemplates(dispatch);
    };
    getTemplateData();
  }

  componentDidUpdate = ({ template_key: prev_template_key }) => {
    const { dispatch, template_key } = this.props;
    if (prev_template_key !== template_key) {
      getImageMetaData(template_key, dispatch, 'TemplateBucket');
    }
  };

  handleShow = () => {
    this.setState({
      show: true
    });
  };

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  onDrop = acceptedFiles => {
    const { dispatch } = this.props;
    if (!isEmpty(acceptedFiles)) {
      const file = acceptedFiles[0];
      getImageForCrop(file, dispatch);
      this.handleShow();
    }
  };

  renderLoading = () => (
    <div className="product-img">
      <div id="image_overlay">
        <Spinner type="regular" />
      </div>
    </div>
  );

  renderReady = img_url => (
    <div className="product-img">
      <img src={img_url} alt="" />
    </div>
  );

  renderReading = (img_url, styles) => (
    <div className="product-img" style={styles.signing.div_thumbnail}>
      <img src={img_url} alt="" style={styles.signing.img} />
      <div id="image_overlay" style={styles.signing.div_overlay}>
        <div className="progress" style={{ marginRight: '2rem' }}>
          <div
            className="progress-bar progress-bar-triangles active"
            style={{ width: '0%' }}
          />
        </div>
      </div>
    </div>
  );

  renderSigning = (img_url, styles) => (
    <div className="product-img" style={styles.signing.div_thumbnail}>
      <img src={img_url} alt="" style={styles.signing.img} />
      <div id="image_overlay" style={styles.signing.div_overlay}>
        <div className="progress" style={{ marginRight: '2rem' }}>
          <div
            className="progress-bar progress-bar-triangles active"
            style={{ width: '30%' }}
          />
        </div>
      </div>
    </div>
  );

  renderUploading = (img_url, styles) => (
    <div className="product-img" style={styles.signing.div_thumbnail}>
      <img src={img_url} alt="" style={styles.signing.img} />
      <div id="image_overlay" style={styles.signing.div_overlay}>
        <div className="progress" style={{ marginRight: '2rem' }}>
          <div
            className="progress-bar progress-bar-triangles active"
            style={{ width: '60%' }}
          />
        </div>
      </div>
    </div>
  );

  renderTransforming = (img_url, styles) => (
    <div className="product-img" style={styles.signing.div_thumbnail}>
      <img src={img_url} alt="" style={styles.signing.img} />
      <div id="image_overlay" style={styles.signing.div_overlay}>
        <div className="progress" style={{ marginRight: '2rem' }}>
          <div
            className="progress-bar progress-bar-triangles active"
            style={{ width: '90%' }}
          />
        </div>
      </div>
    </div>
  );

  clickDownload = () => {
    const { download_url } = this.props;
    window.location.href = download_url;
  };

  renderComplete = img_url => (
    <div className="product-img">
      <img src={img_url} alt="" />
    </div>
  );

  render() {
    const {
      LOADING,
      FETCHING_TEMPLATE_METADATA,
      READY,
      READING,
      READ,
      SIGNING,
      SIGNED,
      UPLOADING,
      UPLOADED,
      TRANSFORMING,
      COMPLETE,
      FETCHING_TEMPLATE_METADATA_FAILED: METADATAFAILED
    } = actions.types;
    const {
      status,
      template_key,
      templates,
      watermarked_url,
      buyStatus
    } = this.props;
    let chunk;
    let txt = 'Choose an image';
    let dropzoneDisabled = false;
    const img_url = `https://s3.${config.region}.amazonaws.com/${
      config.TemplateBucket
    }/${template_key}_preview`;
    const matchingTemplate = templates[template_key];

    switch (status) {
      case LOADING:
      case FETCHING_TEMPLATE_METADATA:
        chunk = this.renderLoading();
        dropzoneDisabled = true;
        break;
      case READY:
      case READING:
      case READ:
        chunk = this.renderReady(img_url, matchingTemplate);
        break;
      case SIGNING:
      case SIGNED:
        chunk = this.renderSigning(img_url, this.styles);
        break;
      case UPLOADING:
      case UPLOADED:
        chunk = this.renderUploading(img_url, this.styles);
        break;
      case TRANSFORMING:
        chunk = this.renderTransforming(img_url, this.styles);
        break;
      case COMPLETE:
        chunk = this.renderComplete(watermarked_url);
        txt = 'Choose another image';
        break;
      case METADATAFAILED:
        chunk = this.renderReady(img_url);
        dropzoneDisabled = true;
        break;
      default:
        chunk = this.renderReady(img_url);
        break;
    }
    return (
      <div className="container">
        <div className="product">
          {!dropzoneDisabled && (
            <div className="dragdrop-msg">
              Drag and drop your image
              <img
                className="dragdrop-icon"
                src={dragIcon}
                width="310"
                alt=""
              />
            </div>
          )}
          <Dropzone
            onDrop={this.onDrop}
            accept="image/jpeg, image/gif, image/png"
            multiple={false}
            className="product-picarea"
            acceptStyle={this.styles.acceptFile}
            disabled={dropzoneDisabled}
          >
            <div className="product-picarea">{chunk}</div>
          </Dropzone>
          <div className="product-details">
            {matchingTemplate && (
              <div>
                <h1 className="product-title">{matchingTemplate.name}</h1>
                <p className="product-desc">{matchingTemplate.description}</p>
              </div>
            )}
            <div className="product-actions">
              {(status === READY || status === READ || status === COMPLETE) && (
                <Fragment>
                  <FileButton
                    txt={txt}
                    handleShow={this.handleShow}
                    classname="btn btn-bevel btn-block"
                  />
                  {status === READY && (
                    <div className="product-note">.JPG, .PNG, or .GIF</div>
                  )}
                </Fragment>
              )}
              {(status === COMPLETE || status === READ) && (
                <CropModal
                  handleClose={this.handleClose}
                  show={this.state.show}
                />
              )}
              {status === COMPLETE &&
                buyStatus !== buy.types.COMPLETE && (
                  <button
                    className="btn btn-bevel btn-block"
                    onClick={this.handleShow}
                  >
                    Re-crop image
                  </button>
                )}
            </div>
            <div className="product-cta">
              <BuyButton uploadComplete={status === COMPLETE} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const featureimageStateToProps = state => ({
  templates: state.s3Templates.templatesJSON.templates,
  template_key: state.uploads.template_key,
  preview_url: state.uploads.preview_url,
  watermarked_url: state.uploads.watermarked_url,
  status: state.uploads.status,
  download_url: state.buy.main_url,
  buyStatus: state.buy.status,
  file_data: state.uploads.file_data
});
export const FeatureImage = connect(featureimageStateToProps)(
  FeatureImage_Class
);



// WEBPACK FOOTER //
// ./src/comps/Feature/FeatureImage.js